import { logUnifiedTelemetry, logUsage } from 'owa-analytics';
import type { MailboxInfo } from 'owa-client-types';
import {
    type UTCalendarEventFeatureAction,
    type UTCalendarFeatureName,
    type UTCalendarUIContext,
    type IUTECalendarEventUserActionArgs,
    type UTEventLocationMetrics,
} from 'owa-unified-telemetry';

export type LocationUserActionAdditionalData = Partial<
    Omit<
        IUTECalendarEventUserActionArgs,
        | 'FeatureName'
        | 'FeatureAction'
        | 'FeatureUIContext'
        | 'EventLocationMetrics'
        | 'IsRecurring'
        | 'IsOnlineMeeting'
        | 'IsAllDay'
    >
>;

export interface LogEventLocationUserActionOptions {
    mailboxInfo?: MailboxInfo;
    featureUIContext: UTCalendarUIContext;
    eventLocationMetrics: UTEventLocationMetrics;
    isRecurring?: boolean;
    isOnlineMeeting?: boolean;
    isAllDay?: boolean;
    additionalData?: LocationUserActionAdditionalData;
}

export function logEventLocationSaveUserAction(options: LogEventLocationUserActionOptions): void {
    const data: IUTECalendarEventUserActionArgs = {
        FeatureName: 'EventLocation',
        FeatureAction: 'SaveLocation',
        FeatureUIContext: options.featureUIContext,
        EventLocationMetrics: options.eventLocationMetrics,
        IsRecurring: options.isRecurring,
        IsOnlineMeeting: options.isOnlineMeeting,
        IsAllDay: options.isAllDay,
        ...options.additionalData,
    };

    logUsage('CalendarEventUserAction', options.mailboxInfo, undefined, {
        unifiedTelemetry: {
            eventName: 'CalendarEventUserAction',
            bypassEventMatchingCheck: true,
            data,
        },
    });
}

export function logEventLocationRemoveUserAction(options: LogEventLocationUserActionOptions): void {
    const data: IUTECalendarEventUserActionArgs = {
        FeatureName: 'EventLocation',
        FeatureAction: 'Remove',
        FeatureUIContext: options.featureUIContext,
        EventLocationMetrics: options.eventLocationMetrics,
        IsRecurring: options.isRecurring,
        IsOnlineMeeting: options.isOnlineMeeting,
        IsAllDay: options.isAllDay,
        ...options.additionalData,
    };

    logUnifiedTelemetry({
        eventName: 'CalendarEventUserAction',
        data,
    });
}
